import { DestroyRef, Injectable, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';

/**
 * Estado das navegações do router, compartilhado pelos indicadores de carregamento.
 *
 * Uma navegação pode demorar para trocar a tela (guards, download dos chunks lazy);
 * nesse intervalo o Angular mantém a página anterior. `emAndamento` só liga após
 * {@link NavegacaoService.ATRASO_MS} para não piscar em navegações rápidas.
 */
@Injectable({ providedIn: 'root' })
export class NavegacaoService {
  static readonly ATRASO_MS = 200;

  readonly emAndamento = signal(false);
  readonly primeiraCargaConcluida = signal(false);

  private timer?: ReturnType<typeof setTimeout>;

  constructor() {
    inject(Router).events.pipe(takeUntilDestroyed()).subscribe((evento) => {
      if (evento instanceof NavigationStart) {
        this.limparTimer();
        this.timer = setTimeout(() => this.emAndamento.set(true), NavegacaoService.ATRASO_MS);
      } else if (
        evento instanceof NavigationEnd ||
        evento instanceof NavigationCancel ||
        evento instanceof NavigationError
      ) {
        this.limparTimer();
        this.emAndamento.set(false);
        this.primeiraCargaConcluida.set(true);
      }
    });

    inject(DestroyRef).onDestroy(() => this.limparTimer());
  }

  private limparTimer(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
  }
}
